var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("CapSetting", {
        attrs: {
          "cap-settings-type": _vm.capSettingType,
          "call-caps": _vm.callCaps,
          "settings-object-container": _vm.payoutCapacity,
          "cap-fields-translation": _vm.capFieldsTranslaction,
          "translation-dictionary": _vm.translactionDictionary,
          "enable-caps-label": _vm.enableCapsLabel,
          "enable-caps-tooltip": _vm.enableCapsTooltip,
          "additional-cap-settings": _vm.additionalCapSettings,
          readonly: _vm.affiliateView
        },
        on: {
          "change-call-caps": _vm.changeCallCaps,
          "change-settings-object-container": _vm.changeSettingsObjectContainer,
          "remove-caps": function($event) {
            return _vm.removeCaps()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }